import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doors, colors, wood_mtls } from "../door.js";
import "./Door.css";

function Door() {
  const { id } = useParams();
  const navigate = useNavigate();
  const door = doors[id];
  const [processedImage, setProcessedImage] = useState(door.image);

  const handleColorSelect = (colorName, materialType) => {
    setProcessedImage(
      `/api/process/${
        door.name
      }/${colorName.toLowerCase()}?material_type=${materialType}`
    );
  };

  return (
    <div className="door-page">
      <button className="back-button" onClick={() => navigate("/")}>
        ← Back to Doors
      </button>

      <div className="content">
        <div className="preview">
          <h2>Preview</h2>
          {processedImage ? (
            <img
              src={processedImage}
              alt="Processed door"
              className="processed-image"
            />
          ) : (
            <div className="placeholder">Select a color to see preview</div>
          )}
        </div>

        <div className="color-selection">
          <h2>Select a Color</h2>
          <div className="color-grid">
            {colors.map((color) => (
              <div
                key={color.id}
                className="color-card"
                onClick={() => handleColorSelect(color.name)}
              >
                <img src={color.image} alt={color.name} />
                <p>{color.name}</p>
              </div>
            ))}
          </div>
          <br />
          <h3>Wood Texture</h3>
          <div className="color-grid">
            {wood_mtls.map((color) => (
              <div
                key={color.id}
                className="color-card"
                onClick={() => handleColorSelect(color.name, "wood")}
              >
                <img src={color.image} alt={color.name} />
                <p>{color.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Door;
